import { AgentComponentMode } from '@reach/shared-types/agent-components';
import { usePartnerProfile } from '../../../hooks/usePartnerSettings';
import { MODE_COPY } from '../agents-copy';
import { TENANT_PREVIEW_COPY } from './component-page-copy';
import styles from './TenantPreviewCard.module.css';

interface TenantControlProps {
  mode: AgentComponentMode;
}

export const TenantControl = ({ mode }: TenantControlProps) => {
  const { partner } = usePartnerProfile();

  if (mode === AgentComponentMode.ALWAYS_ON) {
    const setByLabel = partner
      ? TENANT_PREVIEW_COPY.setBy(partner.name)
      : MODE_COPY[AgentComponentMode.ALWAYS_ON].label;
    return <span className={styles.setBy}>{setByLabel}</span>;
  }
  const switchIsOn = mode === AgentComponentMode.DEFAULT_ON;
  const switchLabel = switchIsOn ? TENANT_PREVIEW_COPY.switchedOn : TENANT_PREVIEW_COPY.switchedOff;
  return <span className={styles.switch} data-on={switchIsOn} role="img" aria-label={switchLabel} />;
};
